import React, { useContext, useEffect, useState } from "react";
import api from "../../../services/api";
import { formatDateTime } from "../../../helpers/helpers";
import AppContext from "../../../container/context";
import Form from "../../../components/form";
import estoqueOperacao from "../../../enums/estoqueOperacao";
import ActionTable from "../../../components/table/ActionTable";

export default function Estoque({ produtoId }) {
  const { notification } = useContext(AppContext);
  const [movimentacoes, setMovimentacoes] = useState([]);
  const [disponibilidade, setDisponibilidade] = useState(0);
  const [recursoId, setRecursoId] = useState(0);
  const [novaMovimentacao, setnNovaMovimentacao] = useState(false);

  useEffect(() => {
    listarMovimentacoes();
  }, []);

  const listarMovimentacoes = () => {
    api
      .get("estoque/movimentacoes", { produtoId: produtoId })
      .then((dados) => {
        const { movimentacoes, disponibilidade } = dados;

        movimentacoes.forEach((m) => {
          m.dataHora = formatDateTime(m.dataHora, "D/M/Y h:m");
        });

        setMovimentacoes(movimentacoes);
        setDisponibilidade(disponibilidade);
      })
      .catch((err) =>
        notification("error", "Erro ao obter as movimentacoes de estoque")
      );
  };

  const formQtdDisponivel = {
    title: "Disponibilidade",
    form: {
      quantidade: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Quantidade em estoque</h4>
            <p>{disponibilidade}</p>
          </div>
        ),
      },
    },
  };

  const tbMovimentacoes = {
    title: "Movimentações",
    array: movimentacoes,
    columns: [
      {
        name: "dataHora",
        label: "Data/hora",
      },
      {
        name: "operacao",
        label: "Operação",
        domain: estoqueOperacao,
      },
      {
        name: "quantidade",
        label: "Quantidade",
      },
      {
        name: "anotacao",
        label: "Anotação",
      },
    ],
    //key: 'id',
    newItemAction: () => setnNovaMovimentacao(true),
    onLineClick: (recurso) => setRecursoId(recurso.id),
  };

  const formularioNovaMovimentacao = () => {
    return {
      operacao: {
        label: "Operação",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: [
            { id: 1, nome: "Entrada" },
            { id: 2, nome: "Saída" },
            { id: 3, nome: "Estorno" },
          ],
          value: "id",
          desc: "nome",
        },
      },
      quantidade: {
        label: "Quantidade",
        type: "number",
        required: true,
        space: 6,
      },
      anotacao: {
        name: "Anotação",
        type: "textarea",
      },
    };
  };

  const adicionarMovimentacao = (formulario) => {
    const movimentacaoIncluir = formulario;

    movimentacaoIncluir.produtoId = produtoId;

    api
      .put("estoque/movimentar", movimentacaoIncluir)
      .then((res) => {
        notification("success", "Movimentação incluída!");
        setnNovaMovimentacao(false);
        listarMovimentacoes();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Operação inválida");
          case 2:
            return notification("error", "Quantidade inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const formNovaMovimentacao = {
    title: "Inserir movimentação",
    form: formularioNovaMovimentacao(),
    submit: {
      label: "Adicionar",
      action: adicionarMovimentacao,
    },
    close: {
      label: "Fechar",
      action: () => {
        setnNovaMovimentacao(false);
      },
    },
  };

  return (
    <div>
      <h2>Estoque</h2>
      {novaMovimentacao ? (
        <Form formData={formNovaMovimentacao} />
      ) : (
        <div>
          <Form formData={formQtdDisponivel} />

          <ActionTable structure={tbMovimentacoes} />
        </div>
      )}
    </div>
  );
}
